<template>
    <main-site>
        <template #main_content>
            <div class=" mx-auto">
                <span v-if="googleAdsUserRegisterPopup && googleAdsUserRegisterPopup == 4"
                    class="google_ads_user_register_from_master_popup" 
                    id="google_ads_user_register_from_master_popup"></span>
                <invoice-template :data="order" />
            </div>
        </template>
    </main-site>
</template>

<script>
import InvoiceTemplate from "@/Pages/Components/InvoiceTemplate";
import MainSite from "@/Pages/Components/MainSite";
export default {
    name: "Invoice",
    components: {InvoiceTemplate,MainSite},
    props:{
        order:Object,
    },
    data() {
        return {
            googleAdsUserRegisterPopup: this.$page.props.google_ads_user_register_popup,
        }
    },
    mounted() {
        window.onload = function(event) {
            if ( performance.navigation.type > 1 ) {
                var elem = document.getElementById("google_ads_user_register_from_master_popup");
                elem.parentNode.removeChild(elem);
            }
        };

        // google ads
        if ( this.googleAdsUserRegisterPopup && this.googleAdsUserRegisterPopup >= 4 ) {
            setTimeout( function() {
                var elem = document.getElementById("google_ads_user_register_from_master_popup");
                elem.parentNode.removeChild(elem);
            },3000);
        }
    },
}
</script>

<style scoped>

</style>
